import Router from 'vue-router';
let LessonList = (resolve) => require(['../page/lesson/lessonList.vue'],resolve);
let BankList =(resolve) => require(['../page/bank/bankList.vue'],resolve);
let ExerciseList =(resolve) => require(['../page/exercise/exerciseList.vue'],resolve);
let Personal =(resolve) => require(['../page/personal/personal.vue'],resolve);
let KnowledgeState = (resolve) => require(['../page/knowledgeState/knowledgeState.vue'], resolve);
let Lessondetail =(resolve) => require(['../page/lesson/lessondetail.vue'],resolve);
let Lessonexercise =(resolve) => require(['../page/lesson/lessonexercise.vue'],resolve);

let TeacherLessonList =(resolve) => require(['../page/teacher/lesson/lessonList.vue'],resolve);
let ProblemBank =(resolve) => require(['../page/teacher/lesson/problemBank.vue'],resolve);

let QuestionList =(resolve) => require(['../page/teacher/question/questionlist.vue'],resolve);
let NewQuestion =(resolve) => require(['../page/teacher/question/newquestion.vue'],resolve);
let QuestionProblemSubmissions =(resolve) => require(['../page/teacher/question/questionProblemSubmissions.vue'],resolve);
let CodeReviewList =(resolve) => require(['../page/teacher/question/codeReviewList.vue'],resolve);
let CodeReviewDetail =(resolve) => require(['../page/teacher/question/codeReviewDetail.vue'],resolve);
let TeacherQuestionPreview =(resolve) => require(['../page/teacher/question/markdownPreview.js'],resolve);
let StandardSolution =(resolve) => require(['../page/teacher/question/standardSolution.vue'],resolve);

let TeacherExerciseList =(resolve) => require(['../page/teacher/exercise/exerciseList.vue'],resolve);
let TeacherExerciseDetail =(resolve) => require(['../page/teacher/exercise/exercisedetail.vue'],resolve);
let TeacherNewExercise =(resolve) => require(['../page/teacher/exercise/newexercise.vue'],resolve);
let TeacherExerciseRanking =(resolve) => require(['../page/teacher/exercise/exerciseRanking.vue'],resolve);

let MemberPass =(resolve) => require(['../page/teacher/member/memberpass.vue'],resolve);
let MemberUnpass =(resolve) => require(['../page/teacher/member/memberunpass.vue'],resolve);
let MemberAdd =(resolve) => require(['../page/teacher/member/memberadd.vue'],resolve);

let TeacherNewLesson =(resolve) => require(['../page/teacher/lesson/newlesson.vue'],resolve);
let TeacherLessonIpRecords =(resolve) => require(['../page/teacher/lesson/lessonIpRecords.vue'],resolve);
let KnowledgeAnalytics =(resolve) => require(['../page/teacher/lesson/knowledgeAnalytics.vue'],resolve);

let TeacherResources =(resolve) => require(['../page/teacher/resources/resources'],resolve);
let ExperimentalReport =(resolve) => require(['../page/teacher/experimentalReport/experimentalReport'],resolve);
let NewReport =(resolve) => require(['../page/teacher/experimentalReport/newReport'],resolve);
let submitReport =(resolve) => require(['../page/lesson/submitReport'],resolve);
let studentSubmitReport =(resolve) => require(['../page/teacher/experimentalReport/studentSubmitReport'],resolve);
let studentSubmitReportDetail =(resolve) => require(['../page/teacher/experimentalReport/studentSubmitReportDetail'],resolve);

let TeacherMessageBoard = (resolve) => require(['../page/teacher/messageBoard/messageBoard.vue'],resolve);
let AdminLayout = (resolve) => require(['../page/admin/AdminLayout.vue'], resolve);
let AdminDashboard = (resolve) => require(['../page/admin/dashboard/AdminDashboard.vue'], resolve);
let AdminTeacherList = (resolve) => require(['../page/admin/teachers/AdminTeacherList.vue'], resolve);
let AdminDepartmentList = (resolve) => require(['../page/admin/departments/AdminDepartmentList.vue'], resolve);
let AdminAiServiceConfig = (resolve) => require(['../page/admin/ai/AdminAiServiceConfig.vue'], resolve);
let AdminAiOperations = (resolve) => require(['../page/admin/ai/AdminAiOperations.vue'], resolve);
let AdminKnowledgePointList = (resolve) => require(['../page/admin/knowledgePoints/AdminKnowledgePointList.vue'], resolve);
let AdminAccountDirectory = (resolve) => require(['../page/admin/accounts/AdminAccountDirectory.vue'], resolve);
let AdminCourseList = (resolve) => require(['../page/admin/courses/AdminCourseList.vue'], resolve);
let AdminSmsPhoneList = (resolve) => require(['../page/admin/sms/AdminSmsPhoneList.vue'], resolve);
let AdminSmsRecordList = (resolve) => require(['../page/admin/sms/AdminSmsRecordList.vue'], resolve);


// import Login from '../page/login/login.vue'
let Login = (resolve) => require(['../page/login/login.vue'],resolve);
let Regist = (resolve) => require(['../page/login/regist.vue'],resolve);

let Home =  (resolve) => require(['../page/home/home.vue'],resolve);

import remind from '@/network/remind';
import {
  clearAuthState,
  getDefaultHomePath,
  getFallbackPath,
  getLoginPathByPath,
  getRequiredRole,
  getRoleHomePath,
  getUserRole,
  hasLogin,
  isRouteWhiteListed
} from '@/common/auth';

Vue.use(Router)

let lastRouteWarning = {
  key: '',
  time: 0
};

function warnRoute(key, message) {
  const now = Date.now();
  if (lastRouteWarning.key === key && now - lastRouteWarning.time < 1500) {
    return;
  }
  lastRouteWarning = {
    key,
    time: now
  };
  remind.message(message, 'warning');
}

const routes = [
  {
    path: '',
    //重定向，默认的首页
    //redirect: '/login'
    redirect: '/login'
  },
  {
    path: '/login',
    name:'Login',
    // component: Login,
    component: Login,
  },
  {
    path: '/teacher/login',
    name:'Login',
    component: Login,

  },
  {
    path: '/teacher/regist',
    name: 'TeacherRegist',
    component: Regist,
  },
  {
    path: '/mooc/regist',
    name: 'MoocRegist',
    component: Regist,
  },
  {
    path: '/teacherHome',
    name: 'Home',
    component: Home,
    children:[
      {
        path: '',
        name: 'TeacherLessonList',
        component: TeacherLessonList
      },
      {
        path: 'lessonList',
        component: TeacherLessonList,
        name: "TeacherLessonList"
      },
      {
        path: 'lessonList/lessondetail',
        component: TeacherNewLesson,
        name: 'TeacherNewLesson'
      },
      {
        path: 'lessonList/newLesson',
        component: TeacherNewLesson,
        name: 'TeacherNewLesson'
      },
      {
        path: 'problemBank',
        component: ProblemBank,
        name: 'ProblemBank'
      },
      {
        path: 'problemBank/detail',
        component: NewQuestion,
        name: 'ProblemBankDetail'
      },
      {
        path: 'questionlist',
        component: QuestionList,
        name: 'QuestionList'
      },
      {
        path: 'exerciseList',
        component: TeacherExerciseList,
        name: 'TeacherExerciseList'
      },
      {
        path: 'personal',
        component: Personal,
        name: 'personal'
      },
      {
        path: 'messageBoard',
        component: TeacherMessageBoard,
        name: 'TeacherMessageBoard'
      },
      {
        path: 'exerciseList/exercisedetail',
        component: TeacherExerciseDetail,
        name: 'TeacherExerciseDetail'
      },
      {
        path: 'exerciseList/newexercise',
        component: TeacherNewExercise,
        name: 'TeacherNewExercise'
      },
      {
        path: 'exerciseList/ranking',
        component: TeacherExerciseRanking,
        name: 'TeacherExerciseRanking'
      },
      {
        path: 'questionlist/questionDetail',
        component: NewQuestion,
        name: 'NewQuestion'
      },
      {
        path: 'questionlist/problemSubmissions',
        component: QuestionProblemSubmissions,
        name: 'QuestionProblemSubmissions'
      },
      {
        path: 'questionlist/codeReviews',
        component: CodeReviewList,
        name: 'CodeReviewList'
      },
      {
        path: 'questionlist/codeReviews/detail',
        component: CodeReviewDetail,
        name: 'CodeReviewDetail'
      },
      {
        path: 'questionlist/standardSolution',
        component: StandardSolution,
        name: 'StandardSolution'
      },
      {
        path: 'memberpass',
        component: MemberPass,
        name: 'MemberPass'
      },
      {
        path: 'memberunpass',
        component: MemberUnpass,
        name: 'MemberUnpass'
      },
      {
        path: 'memberadd',
        component: MemberAdd,
        name: 'MemberAdd'
      },
      {
        path: 'teacherResources',
        component: TeacherResources,
        name: 'resources'
      },
      {
        path: 'experimentalReport',
        component: ExperimentalReport,
        name: 'experimentalReport'
      },
      {
        path: 'newReport',
        component: NewReport,
        name: 'newReport'
      },
      {
        path: 'studentSubmitReport',
        component: studentSubmitReport,
        name: 'studentSubmitReport'
      },
      {
        path: 'submitReportScore',
        component: studentSubmitReportDetail,
        name:'studentSubmitReportDetail'
      },
      {
        path: 'teacherList',
        redirect: '/adminHome/teachers'
      },
      {
        path: 'lessonList/detail/exercise',
        name: "exercise",
        component: Lessonexercise,
      },
      {
        path: 'lessonList/ipRecords',
        component: TeacherLessonIpRecords,
        name: 'TeacherLessonIpRecords'
      },
      {
        path: 'knowledgeAnalytics',
        component: KnowledgeAnalytics,
        name: 'KnowledgeAnalytics'
      },
    ]
  },
  {
    path: '/teacher/question-preview',
    name: 'TeacherQuestionPreview',
    component: TeacherQuestionPreview,
  },
  {
    path: '/adminHome',
    name: 'AdminHome',
    component: AdminLayout,
    redirect: '/adminHome/dashboard',
    children: [
      {
        path: 'dashboard',
        component: AdminDashboard,
        name: 'AdminDashboard'
      },
      {
        path: 'teachers',
        component: AdminTeacherList,
        name: 'AdminTeacherList'
      },
      {
        path: 'departments',
        component: AdminDepartmentList,
        name: 'AdminDepartmentList'
      },
      {
        path: 'ai-policy',
        redirect: '/adminHome/ai-services'
      },
      {
        path: 'ai-services',
        component: AdminAiServiceConfig,
        name: 'AdminAiServiceConfig'
      },
      {
        path: 'ai-operations',
        component: AdminAiOperations,
        name: 'AdminAiOperations'
      },
      {
        path: 'knowledge-points',
        component: AdminKnowledgePointList,
        name: 'AdminKnowledgePointList'
      },
      {
        path: 'accounts',
        component: AdminAccountDirectory,
        name: 'AdminAccountDirectory'
      },
      {
        path: 'courses',
        component: AdminCourseList,
        name: 'AdminCourseList'
      },
      {
        path: 'sms-phones',
        component: AdminSmsPhoneList,
        name: 'AdminSmsPhoneList'
      },
      {
        path: 'sms-records',
        component: AdminSmsRecordList,
        name: 'AdminSmsRecordList'
      }
    ]
  },
  {
    path: '/studentHome',
    name:'Home',
    component: Home,
    children:[
      {
        path: '',
        name: 'lessonList',
        component: LessonList
      },
      {
        path: 'lessonList',
        name: 'lessonList',
        component: LessonList,

      },
      {
        path: 'lessonList/detail',
        name: "detail",
        component: Lessondetail,

      },
      {
        path: 'lessonList/detail/exercise',
        name: "exercise",
        component: Lessonexercise,
      },
      {
        path: 'bankList',
        name: 'bankList',
        component: BankList
      },
      {
        path: 'bankList/detail/exercise',
        component: Lessonexercise,
        name: 'exercise'
      },
      {
        path: 'exerciseList',
        component: ExerciseList,
        name: 'exerciseList'
      },
      {
        path: 'exerciseList/detail/exercise',
        component: Lessonexercise,
        name:'exercise'
      },
      {
        path: 'personal',
        component: Personal,
        name:'personal'
      },
      {
        path: 'knowledge-state',
        component: KnowledgeState,
        name: 'knowledgeState'
      },
      {
        path: 'lessonList/detail/submitReport',
        component: submitReport,
        name: 'submitReport'
      },
    ]
  },
  {
    path: '*',
    redirect: to => {
      if (hasLogin()) {
        warnRoute('not-found', '页面不存在，已返回主页');
      }
      return getFallbackPath(to.path);
    }
  }
]

const router = new Router({
  mode: "history",
  routes,
  //mode:'hash' //开发时使用
})

// const routerPush = Router.prototype.push
// Router.prototype.push = function push(location) {
//   return routerPush.call(this, location).catch(error => error)
// }


router.beforeEach((to, from, next) => {
  const loggedIn = hasLogin();
  const currentRole = loggedIn ? getUserRole() : '';

  if (isRouteWhiteListed(to.path)) {
    if (loggedIn) {
      if (!currentRole) {
        clearAuthState();
        next();
        return;
      }
      const homePath = getDefaultHomePath();
      if (homePath !== to.path) {
        next({
          path: homePath,
          replace: true
        });
        return;
      }
    }
    next();
    return;
  }

  if (!loggedIn) {
    warnRoute('need-login', '请先登录');
    next({
      path: getLoginPathByPath(to.path),
      replace: true
    });
    return;
  }

  if (!currentRole) {
    clearAuthState();
    warnRoute('invalid-session', '登录状态已失效，请重新登录');
    next({
      path: getLoginPathByPath(to.path),
      replace: true
    });
    return;
  }

  const requiredRole = getRequiredRole(to.path);
  if (requiredRole && requiredRole !== currentRole) {
    warnRoute('forbidden', '当前账号无权访问该页面，已返回主页');
    // 权限回退必须使用角色的固定首页，不能使用旧会话中保存的页面路径。
    // 例如历史 /teacherHome/teacherList 会重定向到管理台，若普通教师再
    // 回退到该历史路径，就会形成同步递归并最终耗尽调用栈。
    const homePath = getRoleHomePath();
    if (homePath === to.path) {
      next(false);
      return;
    }
    next({
      path: homePath,
      replace: true
    });
    return;
  }

  next();
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js